import axios from "axios";
import {
  ACCESS_TOKEN,
  GENERATE_OTP_REQUEST,
  LOGIN_REQUEST,
  REFRESH_TOKEN,
  REFRESH_TOKEN_REQUEST,
} from "../auth/constants";
import { addToTaskQueue, changeTaskFailure, changeTaskSuccess } from "../task-queue/actions";
import { logout } from "../auth/actions";

const failedRequest = (action, error, dispatch, taskId, force_logout = true) => {
  dispatch({
    type: action.type + "_FAILURE",
    payload: error.response || error,
    error: true,
    data: action.data,
  });
  dispatch(changeTaskFailure(taskId, error));
  if (force_logout) dispatch(logout());
  return Promise.reject(error);
};

const successRequest = (action, response, dispatch, taskId) => {
  dispatch(changeTaskSuccess(taskId));
  return dispatch({
    type: action.type + "_SUCCESS",
    payload: response.data,
    status: response.status,
    data: action.data,
  });
};

const apiMiddleware =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    const nextAction = next(action);
    if (!(action.type && action.type.endsWith("REQUEST") && action.payload && action.payload.url)) return nextAction;

    let taskId = `${Date.now()}-${Math.floor(Math.random() * 1e8)}`;
    dispatch(addToTaskQueue(taskId, action, "pending"));

    const baseURL = action.payload.baseURL || process.env.REACT_APP_BASE_API_URL;
    let accessToken;
    accessToken = localStorage.getItem(ACCESS_TOKEN);

    if (!accessToken && action.type !== LOGIN_REQUEST && action.type !== GENERATE_OTP_REQUEST)
      return failedRequest(action, "NO HAVE TOKEN", dispatch, taskId, true);

    const request = { headers: {}, ...action.payload, baseURL };
    if (![LOGIN_REQUEST, REFRESH_TOKEN, GENERATE_OTP_REQUEST].includes(action.type))
      request.headers.authorization = `Bearer ${accessToken}`;

    try {
      const response = await axios(request);
      return successRequest(action, response, dispatch, taskId);
    } catch (error) {
      if (action.type === REFRESH_TOKEN_REQUEST || !error.response || (error.response && error.response.status !== 401))
        return await failedRequest(action, error, dispatch, taskId, false);

      let refreshToken;
      refreshToken = localStorage.getItem(REFRESH_TOKEN);
      if (!refreshToken) return await failedRequest(action, "NO HAVE TOKEN", dispatch, taskId, true);

      const refreshRequest = {
        method: "POST",
        url: "/auth/refresh",
        baseURL,
        data: { refresh: refreshToken },
      };

      let refreshResponse;
      try {
        refreshResponse = await axios(refreshRequest);
      } catch (error) {
        return await failedRequest(action, error, dispatch, taskId, true);
      }
      accessToken = refreshResponse.data.access;
      localStorage.setItem(ACCESS_TOKEN, refreshResponse.data.access);
      request.headers.authorization = `Bearer ${accessToken}`;
      try {
        const response = await axios(request);
        successRequest(action, response, dispatch, taskId);
      } catch (error) {
        return await failedRequest(action, error, dispatch, taskId, false);
      }
    }
  };

export default apiMiddleware;
